import { api, getAllPages } from "./client";
import type {
  Widget,
  CreateWidgetRequest,
  UpdateWidgetRequest,
} from "@/types/widget";

export const getWidgets = () => getAllPages<Widget>("/v1/widgets");

export const getWidget = (id: string) =>
  api.get<Widget>(`/v1/widgets/${id}`);

export const createWidget = (
  data: CreateWidgetRequest,
  options?: { serviceId?: string }
) =>
  api.post<{ id: string }>("/v1/widgets", data, {
    serviceId: options?.serviceId,
  });

export const updateWidget = (id: string, data: UpdateWidgetRequest) =>
  api.patch<{ id: string }>(`/v1/widgets/${id}`, data);

export const deleteWidget = (id: string) =>
  api.delete<{ id: string }>(`/v1/widgets/${id}`);
